import { configureStore } from "@reduxjs/toolkit";
import { contractsApi } from "./contractsApi";
import { legalEntityLookupApi } from "./legalEntityLookupApi";
import { performanceFiguresApi } from "./performanceFiguresApi";
import { homeApi } from "./homeApi";
import { costManagementApi } from "./costManagementApi";
import { authApi } from "./authApi";

export const store = configureStore({
  reducer: {
    [contractsApi.reducerPath]: contractsApi.reducer,
    [legalEntityLookupApi.reducerPath]: legalEntityLookupApi.reducer,
    [performanceFiguresApi.reducerPath]: performanceFiguresApi.reducer,
    [homeApi.reducerPath]: homeApi.reducer,
    [costManagementApi.reducerPath]: costManagementApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(contractsApi.middleware)
      .concat(legalEntityLookupApi.middleware)
      .concat(performanceFiguresApi.middleware)
      .concat(homeApi.middleware)
      .concat(costManagementApi.middleware)
      .concat(authApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
